import { render, staticRenderFns } from "./template-selector.vue?vue&type=template&id=7fbeda56"
import script from "./template-selector.vue?vue&type=script&lang=js"
export * from "./template-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports